import api from '@/helpers/api';

const dataModule = {
    state: {
        isAppLoading: true,
        isOnePage: false,
        isDocumentPageDataLoaded: false,
        mainImage: {
            width: 320,
            height: 471
        },
        zoom: 1,
        isSearchable: false,
        generalInfo: {
            isLogin: false
        },
        imgUrl: '',
        docInfo: {},
        documentPages: null,
        currentTextPage: '',
        currentTextPageFlag: false,
        currentOrderId: null,
        cartPages: [1, 3, 4, 5, 7] // тестовые стартовые значения, удалить при появлении апи
    },
    mutations: {
        SET_IMAGE_URL(state, payload) {
            state.imgUrl = payload;
        },
        SET_APP_LOADING(state, payload) {
            state.isAppLoading = payload;
        },
        SET_IMAGE_NATURAL_PARAMS(state, payload) {
            state.mainImage = payload;
        },
        SET_DOCUMENT_PAGE_DATA_LOADED(state, payload) {
            state.isDocumentPageDataLoaded = payload;
        },
        SET_GENERAL_INFO(state, payload) {
            state.generalInfo = payload;
        },
        SET_NEW_ZOOM(state, zoom) {
            state.zoom = zoom;
        },
        SET_SEARCH_STATUS(state, flag) {
            state.isSearchable = flag;
        },
        SET_DOCUMENT_PAGES(state, payload) {
            state.generalInfo = { ...state.generalInfo, maxPages: payload };
        },
        SET_TEXT_PAGE_FLAG(state) {
            state.currentTextPageFlag = !state.currentTextPageFlag;
        },
        SET_ONE_PAGE_STATE(state, payload) {
            state.isOnePage = payload;
        },
        SET_DOCUMENT_INFO(state, params) {
            state.docInfo = params;
        },
        SET_CURRENT_ORDER_ID(state, id) {
            state.currentOrderId = id;
        },
        ADD_TO_CART(state, pages) {
            state.cartPages = state.cartPages.concat(pages);
        }
    },
    actions: {
        async fetchDocumentPagesById({ commit, dispatch }, payload) {
            try {
                const { data } = await api.get(`/api/viewer/pdf?docId=${payload}&pageCount=all`);
                if (!data) throw new Error('не удалось получить количество страниц');
                commit('SET_DOCUMENT_PAGES', data);
                return data;
            } catch (error) {
                dispatch('showNotification', error);
            }
            return false;
        },
        async fetchGeneralInfoById({ commit }, payload) {
            const { data } = await api.get(`/api/loader/get_general_info/${payload}`);
            commit('SET_GENERAL_INFO', {
                title: data.doc_title,
                isAvailable: data.is_available,
                isOpen: data.is_open_access,
                infoText: data.general_message,
                advText: data.additional_message,
                systems: data.systems,
                isLogin: data.is_login,
                userInfo: data.user_info
            });
            return data;
        },
        async fetchDocumentInfo({ commit }, payload) {
            try {
                const { data } = await api.get(`${process.env.VUE_APP_SEARCH_URL}/ru/front-api/document/${payload}`);
                commit('SET_DOCUMENT_INFO', data.data.item);
                return data;
            } catch (err) {
                throw new Error('вы пытаетесь открыть не существующий документ');
            }
        },
        async checkDocumentHasTextSearch({ commit, dispatch }, payload) {
            try {
                const { data } = await api.get(`/api/viewer/pdf?docId=${payload}&isSearchable=get`);
                if (!data) throw new Error('не удалось проверить документ на поиск по тексту');
                commit('SET_SEARCH_STATUS', data);
                return data;
            } catch (error) {
                dispatch('showNotification', error);
            }
            return false;
        },
        async textSearchInDocument(context, payload) {
            const encoded = encodeURI(payload.value);
            const { data } = await api.get(`/api/viewer/pdf?docId=${payload.id}&search=${encoded}`);
            return data;
        }
    },
    getters: {
        isAppLoading: state => state.isAppLoading,
        isDocumentPageDataLoaded: state => state.isDocumentPageDataLoaded,
        getMainImageParams: state => state.mainImage,
        getZoom: state => state.zoom,
        getMainImgZoomWidth: state => state.mainImage.width * state.zoom,
        getMainImgZoomHeight: state => state.mainImage.height * state.zoom,
        getIsSearchable: state => state.isSearchable,
        getGeneralInfo: state => state.generalInfo,
        getTextPageCurrentFlag: state => state.currentTextPageFlag,
        getIsOnePage: state => state.isOnePage,
        getUserName: (state) => {
            if (state.generalInfo.userInfo) {
                return `${state.generalInfo.userInfo.firstname} ${state.generalInfo.userInfo.lastname}`;
            }
            return '';
        },
        getDocInfo: state => state.docInfo,
        getOrderId: state => state.currentOrderId,
        getCartPages: state => state.cartPages,
        getImageUrl: state => state.imgUrl
    }
};

export default dataModule;
